var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mandatory && !_vm.selectedSomething
        ? _c("div", { staticClass: "error mb-2" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.mandatory.errorMessage) + "\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.nothing
        ? _c(
            "div",
            { staticClass: "mb-2" },
            [
              _c(
                "b-form-checkbox",
                {
                  on: { change: _vm.onNothingChanged },
                  model: {
                    value: _vm.nothingSelection,
                    callback: function($$v) {
                      _vm.nothingSelection = $$v
                    },
                    expression: "nothingSelection"
                  }
                },
                [_vm._v("\n\t\t\t" + _vm._s(_vm.nothing.label) + "\n\t\t")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.preparedCharacteristics, function(characteristic) {
        return _c("characteristic-tree-select-item", {
          key: characteristic.id,
          attrs: {
            characteristics: _vm.characteristics,
            characteristic: characteristic,
            selected: _vm.selected
          },
          on: { change: _vm.onSelectionChanged }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }